import logo from "./logo.svg";
import "./App.css";

// Components
import Navbar from "./components/navbar.component";
import Footer from "./components/footer.component";
import Contact from "./components/contact.component";
import Projects from "./components/projects.component";
import Hero from "./components/hero-section.component";

// Importing Data
import userData from "./data/user.data";
const { Name, CVUrl, GithubUrl, LinkedinUrl, ProjectsUrl, ContactFormUrl } =
  userData;

function App() {
  return (
    <div className="App">
      <Navbar
        Name={Name}
        CVUrl={CVUrl}
        GithubUrl={GithubUrl}
        LinkedinUrl={LinkedinUrl}
      />
      <Hero
        Name={Name}
        CVUrl={CVUrl}
        GithubUrl={GithubUrl}
        LinkedinUrl={LinkedinUrl}
      />
      <Projects ProjectsUrl={ProjectsUrl} />
      <Contact ContactFormUrl={ContactFormUrl} />
      <Footer GithubUrl={GithubUrl} LinkedinUrl={LinkedinUrl} />
    </div>
  );
}

export default App;
